/**
 * Hook para carregar configuração Azure do Lovable Cloud
 */

import { useState, useEffect } from "react";
import { getAzureConfig, AzureConfig } from "@/services/azureConfigClient";
import { logger } from "@/utils/logger"

export const useAzureConfig = () => {
  const [config, setConfig] = useState<AzureConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        setLoading(true);
        const data = await getAzureConfig();
        setConfig(data);
        setError(null);
      } catch (err: any) {
        logger.error("[useAzureConfig] Failed to load config:", err);
        setError(err.message || "Failed to load Azure configuration");
        setConfig(null);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  return { config, loading, error };
};
